"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoAttachmentsTip = exports["default"] = exports.InboxAttachmentList = exports.RecentUpload = exports.UploadZone = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactVirtualized = require("react-virtualized");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactI18next = require("react-i18next");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Button = _interopRequireDefault(require("../Button"));

var _DragableContainer = _interopRequireDefault(require("../ComposeEditor/DragableContainer"));

var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _withStyles = _interopRequireDefault(require("@material-ui/styles/withStyles"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ThemedDialog = (0, _withStyles["default"])(function (_ref) {
  var palette = _ref.palette;
  return {
    paper: {
      maxWidth: 932,
      height: 'calc(100% - 100px)'
    }
  };
})(_Dialog["default"]);
var LEFT_PART_WIDTH = 200;

var LeftPart = function LeftPart(_ref2) {
  var activeTab = _ref2.activeTab,
      tabs = _ref2.tabs,
      _onClick = _ref2.onClick;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "px-2 pt-4 font-semibold text-sm flex-shrink-0 sticky top-0",
    style: {
      width: LEFT_PART_WIDTH
    }
  }, tabs.map(function (tab, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: tab.value,
      className: (0, _classnames["default"])('mb-6 px-4  border-l-4 border-transparent text-gray-light cursor-pointer', {
        'text-primary border-primary': activeTab === index
      }),
      onClick: function onClick(event) {
        return _onClick(index);
      }
    }, tab.label);
  }));
};

var UploadZone = function UploadZone(_ref3) {
  var onUploadFiles = _ref3.onUploadFiles,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled;
  var inputRef = (0, _react.useRef)();

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_DragableContainer["default"], {
    className: "mt-6 flex-grow h-full",
    onDropFiles: function onDropFiles(files) {
      return !disabled && onUploadFiles(files);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "border-2 border-dashed border-secondary flex items-center justify-center text-gray-medium font-semibold h-full",
    style: {
      minHeight: 200
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("div", null, t('uploadDialog.dragAndDrop')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    disabled: disabled,
    size: "sm",
    className: "bg-secondary",
    onClick: function onClick() {
      inputRef.current.value = '';
      inputRef.current.click();
    }
  }, t('button.upload')), /*#__PURE__*/_react["default"].createElement("input", {
    type: "file",
    hidden: true,
    ref: inputRef,
    onChange: function onChange(e) {
      return onUploadFiles((0, _toConsumableArray2["default"])(e.target.files));
    },
    multiple: true
  })))));
};

exports.UploadZone = UploadZone;

var RecentUpload = function RecentUpload(_ref4) {
  var attachments = _ref4.attachments,
      attachmentComponent = _ref4.attachmentComponent,
      selectedAttachments = _ref4.selectedAttachments,
      _onSelect = _ref4.onSelect,
      className = _ref4.className,
      loading = _ref4.loading;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  if (attachments.length === 0) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold py-4"
  }, t('uploadDialog.recentUploads')), loading ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
    fullHeight: true
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap -mx-2 overflow-auto"
  }, attachments.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(attachmentComponent, {
      attachments: attachments,
      index: index,
      key: item.id,
      selected: !!selectedAttachments[item.uuid],
      onSelect: function onSelect() {
        return _onSelect(item);
      },
      size: attachments.length <= 3 ? 'large' : 'normal'
    });
  })));
};

exports.RecentUpload = RecentUpload;
var GridDimensions = {
  NORMAL: {
    columnWidth: 165,
    rowHeight: 125
  },
  LARGE: {
    columnWidth: 330,
    rowHeight: 135
  }
};

var InboxAttachmentList = function InboxAttachmentList(_ref5) {
  var category = _ref5.category,
      attachments = _ref5.attachments,
      attachmentComponent = _ref5.attachmentComponent,
      selectedAttachments = _ref5.selectedAttachments,
      _onSelect2 = _ref5.onSelect,
      className = _ref5.className,
      loading = _ref5.loading,
      loadMore = _ref5.loadMore,
      isLoaded = _ref5.isLoaded,
      total = _ref5.total,
      renderItem = _ref5.renderItem;

  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  var attachmentSize = attachments.length <= 3 ? 'large' : 'normal';
  var _GridDimensions$attac = GridDimensions[attachmentSize.toUpperCase()],
      columnWidth = _GridDimensions$attac.columnWidth,
      rowHeight = _GridDimensions$attac.rowHeight;

  var loaderNode = /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col h-full"
  }, /*#__PURE__*/_react["default"].createElement(_reactVirtualized.InfiniteLoader, {
    isRowLoaded: isLoaded,
    loadMoreRows: loadMore,
    rowCount: total
  }, function (_ref6) {
    var onRowsRendered = _ref6.onRowsRendered,
        registerChild = _ref6.registerChild;
    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, {
      className: "!h-full !w-full flex-grow"
    }, function (_ref7) {
      var height = _ref7.height,
          width = _ref7.width;
      var columnCount = Math.floor(width / columnWidth);
      return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.Grid, {
        ref: registerChild,
        cellRenderer: function cellRenderer(_ref8) {
          var columnIndex = _ref8.columnIndex,
              rowIndex = _ref8.rowIndex,
              rest = (0, _objectWithoutProperties2["default"])(_ref8, ["columnIndex", "rowIndex"]);
          var index = columnIndex + rowIndex * columnCount;
          var attachment = attachments[index];
          return renderItem(_objectSpread(_objectSpread({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          }, rest), {}, {
            selected: !!selectedAttachments[attachment.uuid],
            onSelect: function onSelect() {
              return _onSelect2(attachment);
            },
            size: attachmentSize
          }), index);
        },
        onSectionRendered: function onSectionRendered(_ref9) {
          var columnStartIndex = _ref9.columnStartIndex,
              columnStopIndex = _ref9.columnStopIndex,
              rowStartIndex = _ref9.rowStartIndex,
              rowStopIndex = _ref9.rowStopIndex;
          var startIndex = rowStartIndex * columnCount + columnStartIndex;
          var stopIndex = rowStopIndex * columnCount + columnStopIndex;
          return onRowsRendered({
            startIndex: startIndex,
            stopIndex: stopIndex
          });
        },
        columnWidth: columnWidth,
        columnCount: columnCount,
        height: height,
        rowHeight: rowHeight,
        rowCount: Math.ceil(total / columnCount),
        width: width,
        tabIndex: null
      });
    });
  }));

  var bodyNode = attachments.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex whitespace-pre-line items-center justify-center text-center text-gray-light",
    style: {
      minHeight: 260
    }
  }, t('uploadDialog.emptyCategoryUpload', {
    category: category.toLowerCase(),
    item: category.substring(0, category.length - 1).toLowerCase()
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full",
    style: {
      paddingTop: 32,
      paddingBottom: rowHeight / 2
    }
  }, loaderNode);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold py-1 sticky",
    style: {
      top: '1.5rem'
    }
  }, t('uploadDialog.recentCategory', {
    category: category
  })), loading ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
    fullHeight: true
  })) : bodyNode);
};

exports.InboxAttachmentList = InboxAttachmentList;
var DEFAULT_TAB = 0;

var UploadDialog = function UploadDialog(_ref10) {
  var isOpen = _ref10.isOpen,
      toggle = _ref10.toggle,
      children = _ref10.children,
      onSure = _ref10.onSure,
      _onUploadFiles = _ref10.onUploadFiles,
      _ref10$attachmentCate = _ref10.attachmentCategoryTabs,
      attachmentCategoryTabs = _ref10$attachmentCate === void 0 ? [] : _ref10$attachmentCate,
      props = (0, _objectWithoutProperties2["default"])(_ref10, ["isOpen", "toggle", "children", "onSure", "onUploadFiles", "attachmentCategoryTabs"]);

  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation4.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var rightBarRef = (0, _react.useRef)();

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      selectedAttachments = _useState4[0],
      setSelectedAttachments = _useState4[1];

  var _useState5 = (0, _react.useState)(DEFAULT_TAB),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      activeTab = _useState6[0],
      setActiveTab = _useState6[1];

  var selectedLength = (0, _react.useMemo)(function () {
    return Object.keys(selectedAttachments).length;
  }, [selectedAttachments]);
  var tabs = [{
    value: 'upload',
    label: 'Upload a File'
  }].concat((0, _toConsumableArray2["default"])(attachmentCategoryTabs));
  (0, _react.useEffect)(function () {
    isOpen && setSelectedAttachments({});
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    return rightBarRef.current && rightBarRef.current.scrollIntoView();
  }, [activeTab]);

  var handleClickActiveTab = function handleClickActiveTab(tabIndex) {
    setActiveTab(tabIndex);
  };

  var handleSelect = function handleSelect(attachment) {
    return setSelectedAttachments(function (items) {
      var newValue = _objectSpread({}, items);

      var id = attachment.uuid;

      if (items[id]) {
        delete newValue[id];
      } else {
        newValue[id] = attachment;
      }

      return newValue;
    });
  };

  var handleClose = function handleClose() {
    if (loading) return;
    toggle();
  };

  var handleInsert = function handleInsert(attachment) {
    var res = onSure([attachment]);

    if (res && res.then) {
      setLoading(true);
      res.then(toggle)["finally"](function () {
        return setLoading(false);
      });
    }
  };

  return /*#__PURE__*/_react["default"].createElement(ThemedDialog, {
    open: isOpen,
    onClose: handleClose,
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "absolute right-0 top-0 text-gray-light mr-4 mt-4",
    onClick: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
    className: "!py-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(LeftPart, {
    tabs: tabs,
    activeTab: activeTab,
    onClick: handleClickActiveTab
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow flex flex-col overflow-auto",
    ref: rightBarRef
  }, activeTab === DEFAULT_TAB ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(UploadZone, {
    onUploadFiles: function onUploadFiles(files) {
      _onUploadFiles(files);

      toggle();
    }
  }), children(null, selectedAttachments, handleSelect, handleInsert)) : children(tabs[activeTab].value, selectedAttachments, handleSelect, handleInsert)))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], {
    className: "items-center",
    style: {
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingLeft: 208
    },
    className: "text-gray-light font-semibold text-sm"
  }, selectedLength ? "".concat(selectedLength, " Selected") : ''), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-nowrap inline-flex"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: handleClose,
    disabled: loading,
    color: "white",
    className: "w-32 mr-4"
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      var res = onSure(Object.values(selectedAttachments));

      if (res && res.then) {
        setLoading(true);
        res.then(toggle)["finally"](function () {
          return setLoading(false);
        });
      }
    },
    disabled: !Object.keys(selectedAttachments).length || loading,
    color: "primary",
    className: "w-32 flex items-center justify-center"
  }, t('button.insert'), loading && /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    color: "info",
    size: 20
  })))));
};

var _default = UploadDialog;
exports["default"] = _default;

var NoAttachmentsTip = function NoAttachmentsTip(_ref11) {
  var categoryLabel = _ref11.categoryLabel;

  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation5.t;

  if (!categoryLabel) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 flex whitespace-pre-line items-center justify-center text-center text-gray-light"
  }, t('uploadDialog.emptyCategoryUpload', {
    category: categoryLabel.toLowerCase()
  }));
};

exports.NoAttachmentsTip = NoAttachmentsTip;
//# sourceMappingURL=index.js.map